import {
  EVENT_MAPPING,
  PLATFORM_CODE,
  ANALYTICS_EVENT_NAME,
  ANALYTICS_DEFAULT_CONFIG,
  CONNECTION_SPEED_TYPE,
  ANALYTICS_DEFAULT_PULSE_CONFIG,
  DEFAULT_PULSE_MAX_COUNT,
  DEFAULT_PULSE_TIME_INTERVAL
} from "./spnAnalytics/analyticsEnum";
import {
  timerValueBasedOnConnection
} from "./spnAnalytics/analytics.util";
import AppSessionStart from "./apiManagement/appSessionStart.api";
import QueueManager from "./apiManagement/queueManager";
import NetworkManager from "./networkManager";
import DataStore from "./dataStore/index";
import ApiRequest from "./xhrServices/index";
import VideoAttempt from "./apiManagement/videoAttempt.api";
import videoSessionStart from "./apiManagement/videoSessionStart.api";
import VideoPlay from "./apiManagement/videoPlay.api";
import VideoError from "./apiManagement/videoError.api";
import VideoEnd from "./apiManagement/videoEnd.api";
import VideoSessionHeartbeat from "./apiManagement/videoSessionHeartbeat.api";
import VideoSessionEnd from "./apiManagement/videoSessionEnd.api";
import AppSessionEnd from "./apiManagement/appSessionEnd.api";
//import DeviceDetector from "device-detector-js";
import CommonEventsKey from "./spnAnalytics/commonEventskey";
import { BEACON_EXECUTE_TIME } from "./spnAnalytics/analyticsEnum";
import AdAttempt from "./adsApiManagement/adAttempt.api";
import AdEnd from "./adsApiManagement/adEnd.api";
import AdError from "./adsApiManagement/adError.api";
import AdHeartbeat from "./adsApiManagement/adHeartbeat.api";
import AdPlay from "./adsApiManagement/adPlay.api";
import AppBackGround from "./apiManagement/AppBackGround";
import AppForeGround from "./apiManagement/AppForeGround";
import ErrorCodeManager from "./apiManagement/errorCodeManager";
import VideoSessionPulse from "./apiManagement/videoSessionPulse.api";

/* The ANALYTICS_CONNECTOR class is the main class that is used to call the other classes. */
class AnalyticsConnector {
  /**
   * It's a constructor function that creates a bunch of objects and assigns them to properties of
   * the object that is being constructed.
   */
  constructor(config) {
    this.config = config || {};
    this.isNetworkProcessActivated = true;
    this.isForeignCountry = false;
    this.platformType = "WEB";
    this.godavariStateAllSessionErrorKey = "ANALYTICS_ALL_ERROR_DATA";
    this.godavariStateAllSessionVideoEndKey = "ANALYTICS_ALL_END_DATA";
    this.analyticsConfig = ANALYTICS_DEFAULT_CONFIG;
    this.analyticsPulseConfig = ANALYTICS_DEFAULT_PULSE_CONFIG;
    this.pulseMaxCount = DEFAULT_PULSE_MAX_COUNT;
    this.pulseTimeInterval = DEFAULT_PULSE_TIME_INTERVAL;
    this.analyticsBeaconName = ANALYTICS_EVENT_NAME;
    this.dataStoreObj = new DataStore(this);
    this.apiRequest = new ApiRequest(this);
    this.networkManagerObj = new NetworkManager(this);
    this.queueManager = new QueueManager(this);
    this.sessionStartObj = new AppSessionStart(this);
    this.videoAttemptObj = new VideoAttempt(this);
    this.videoSessionStartObj = new videoSessionStart(this);
    this.videoPlayObj = new VideoPlay(this);
    this.videoErrorObj = new VideoError(this);
    this.videoEndObj = new VideoEnd(this);
    this.videoSessionHeartbeatObj = new VideoSessionHeartbeat(this);
    this.videoSessionEndObj = new VideoSessionEnd(this);
    this.appSessionEndObj = new AppSessionEnd(this);
    this.adAttemptObj = new AdAttempt(this);
    this.adEndObj = new AdEnd(this);
    this.adErrorObj = new AdError(this);
    this.adHeartbeatObj = new AdHeartbeat(this);
    this.adPlayObj = new AdPlay(this);
    this.appForeGroundObj = new AppForeGround(this);
    this.appBackGroundObj = new AppBackGround(this);
    this.errorCodeManager = new ErrorCodeManager(this);
    this.videoSessionPulseObj = new VideoSessionPulse(this);
    this.appStartData = {};
    this.masterSPNData = {};
    this.lastPulseStatus = true;
    this.playerEventStatus = {
      videoSessionStartStatus: false,
      videoAttemptStatus: false,
      videoPlayStatus: false,
      videoErrorStatus: false,
      videoSessionHeartbeatStatus: false,
      appSessionEndStatus: false,
      videoSessionPulseStatus: false
    };

    this.playerAdsEventStatus = {
      adsVideoAttemptStatus: false,
      adsVideoPlayStatus: false,
      adsVideoErrorStatus: false,
      adsVideoSessionHeartbeatStatus: false,
      adsVideoEndStatus: false
    };

    // this.deviceDetector = new DeviceDetector();
    this.userAgent = navigator.userAgent;
    // this.deviceData = this.deviceDetector.parse(this.userAgent);
    this.staticAnalyticKeys = CommonEventsKey.commonEventKeys();
    this.beaconExecuteStateTime = BEACON_EXECUTE_TIME;
    this.videoSessionId = "";
    this.adsSessionId = "";
    this.videoSessionStartTime = "";
    this.videoAdStartStatus = false;
    if (typeof window.ANALYTICS_CONNECTOR_FRONTEND != "undefined") {
      this.appStartData = { ...window.ANALYTICS_CONNECTOR_FRONTEND.appStartData };
      this.masterSPNData = { ...window.ANALYTICS_CONNECTOR_FRONTEND.masterSPNData };
      this.playerEventStatus =
        { ...window.ANALYTICS_CONNECTOR_FRONTEND.playerEventStatus };
      this.playerAdsEventStatus =
        { ...window.ANALYTICS_CONNECTOR_FRONTEND.playerAdsEventStatus };
      this.videoSessionId = window.ANALYTICS_CONNECTOR_FRONTEND.videoSessionId;
      this.adsSessionId = window.ANALYTICS_CONNECTOR_FRONTEND.adsSessionId;
      this.videoSessionStartTime = window.ANALYTICS_CONNECTOR_FRONTEND.videoSessionStartTime;
      this.platformType = window.ANALYTICS_CONNECTOR_FRONTEND.platformType;
      this.videoAdStartStatus = window.ANALYTICS_CONNECTOR_FRONTEND.videoAdStartStatus;
      this.isForeignCountry = window.ANALYTICS_CONNECTOR_FRONTEND.isForeignCountry;
      this.analyticsConfig = {
        ...this.analyticsConfig,
        ...window.ANALYTICS_CONNECTOR_FRONTEND.analyticsConfig,
      };
      this.lastPulseStatus = window.ANALYTICS_CONNECTOR_FRONTEND.lastPulseStatus;
      this.analyticsPulseConfig = {
        ...this.analyticsPulseConfig,
        ...window.ANALYTICS_CONNECTOR_FRONTEND.analyticsPulseConfig,
      };
      this.pulseMaxCount = {
        ...this.pulseMaxCount,
        ...window.ANALYTICS_CONNECTOR_FRONTEND.pulseMaxCount,
      };
      this.pulseTimeInterval = {
        ...this.pulseTimeInterval,
        ...window.ANALYTICS_CONNECTOR_FRONTEND.pulseTimeInterval,
      };
      this.networkManagerObj.updateConfig(this.analyticsConfig);
      this.queueManager.updateAnalyticsConfig(this.analyticsConfig);
    }
    if (this.config.sender == "self") {
      this.registerBodyOnload();
    }
  }

  setDefaultConfig(appConfig) {
    this.analyticsConfig = { ...this.analyticsConfig, ...appConfig };
    this.networkManagerObj.updateConfig(this.analyticsConfig);
    this.queueManager.updateAnalyticsConfig(this.analyticsConfig);
  }

  registerBodyOnload() {
    if (document.body) {
      this.bodyOnload();
    } else {
      document.addEventListener("DOMContentLoaded", this.bodyOnload.bind(this));
    }
  }

  /**
   * When the page loads, create a session ID and extract the necessary parameters.
   */
  bodyOnload() {
    this.createAppSessionID();
    this.extractNecessaryParams();
  }

  /**
   * It creates a unique ID for the app session.
   * @returns The appSessionId is being returned.
   */
  createAppSessionID() {
    let appSessionId;
    var time = new Date().getTime();
    this.dataStoreObj.setData("appSessionID", time);
    appSessionId = this.dataStoreObj.getData("appSessionID");
    this.appSessionId = appSessionId;
    return appSessionId;
  }

  /**
   * It returns the value of the key "appSessionID" from the dataStoreObj object.
   * @returns The appSessionID
   */
  getAppSessionID() {
    return this.appSessionId.toString();
  }

  /**
   * It returns a string that represents the current date and time in the format of "Month/Day/Year,
   * Hour:Minute:Seconds"
   * @returns The current date and time.
   */
  getTimeDateFormat() {
    let dateTime = new Date().getTime();
    return dateTime.toString();
  }

  /**
   * The Intl.DateTimeFormat() method returns a new DateTimeFormat object for formatting and parsing
   * dates and times in a given locale, with the options specified.
   * @returns The timezone of the user's computer.
   */
  getTimeZone() {
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone;
  }

  getDeviceType() {
    let device = this.userAgent;
    try {
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(device)) {
        return "tablet";
      }
      if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          device
        )
      ) {
        return "mobile";
      }
    } catch (error) {
      SPN_Console.log(error);
    }
    return "desktop";
  }

  getOs() {
    let osName = "windows";
    try {
      if (navigator.appVersion.indexOf("Win") != -1) {
        osName = "windows";
      }
      if (navigator.appVersion.indexOf("Mac") != -1) {
        osName = "mac";
      }
      if (navigator.appVersion.indexOf("X11") != -1) {
        osName = "unix";
      }
      if (navigator.appVersion.indexOf("Linux") != -1) {
        osName = "linux ";
      }
    } catch (error) {
      SPN_Console.log(error);
    }
    return osName;
  }

  /**
   * It extracts the necessary parameters from the browser and stores it in a JSON object.
   * </code>
   */
  extractNecessaryParams() {
    let connectionType = "4g";
    let downloadSpeed = "0.1 Mbps";
    try {
      let connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
      connectionType = connection.effectiveType;
      downloadSpeed = navigator.connection.downlink + " Mbps";
    } catch (error) {
      console.log("Navigator error: " + error);
    }

    var userAgentData = navigator.userAgent;
    if (
      userAgentData.toLowerCase().includes("webos") ||
      userAgentData.toLowerCase().includes("web0s")
    ) {
      userAgentData += " LG 86UP8770PUA";
    }
    this.masterSPNData[EVENT_MAPPING.app_user_agent] = userAgentData;
    this.masterSPNData[EVENT_MAPPING.app_session_id] = this.getAppSessionID();
    this.masterSPNData[EVENT_MAPPING.video_network_type] = connectionType;
    this.masterSPNData[EVENT_MAPPING.video_connection_speed] =
      downloadSpeed.toString();
    this.masterSPNData[EVENT_MAPPING.app_build_version] = ANALYTICS_SDK_VERSION
      ? ANALYTICS_SDK_VERSION
      : "NA";
  }

  /**
   * It sets all the flags to false.
   */
  updatePlayerFlagStatus() {
    this.playerEventStatus.videoSessionStartStatus = false;
    this.playerEventStatus.videoAttemptStatus = false;
    this.playerEventStatus.videoPlayStatus = false;
    this.playerEventStatus.videoErrorStatus = false;
    this.playerEventStatus.videoSessionHeartbeatStatus = false;
    this.playerEventStatus.appSessionEndStatus = false;
  }

  updateAdsPlayerFlagStatus() {
    this.playerAdsEventStatus.adsVideoAttemptStatus = false;
    this.playerAdsEventStatus.adsVideoPlayStatus = false;
    this.playerAdsEventStatus.adsVideoErrorStatus = false;
    this.playerAdsEventStatus.adsVideoSessionHeartbeatStatus = false;
  }

  setVideoSessionId = (eventData) => {
    let platform = "";
    if (this.masterSPNData[EVENT_MAPPING.app_platform_type] == "WEB") {
      platform = PLATFORM_CODE.WEB;
    } else if (this.masterSPNData[EVENT_MAPPING.app_platform_type] == "MWEB") {
      platform = PLATFORM_CODE.MWEB;
    } else {
      platform = PLATFORM_CODE.SMARTTV;
    }
    this.videoSessionStartTime = parseInt(
      eventData.event_wall_clock
    );
    this.masterSPNData[EVENT_MAPPING.video_session_start_time] = parseInt(
      eventData.event_wall_clock
    );

    var osName = this.masterSPNData[EVENT_MAPPING.app_operating_system].replace(/[^a-zA-Z ]/g, "");
    osName = osName.replace(/\s+/g, "_");
    var randNumber = Math.floor(Math.random() * 9000) + 999;
    let vSessionId = platform + "-" + osName?.toLowerCase() + "-" + eventData?.video_content_id + "-" + eventData?.event_wall_clock;
    this.masterSPNData[EVENT_MAPPING.video_session_id] = vSessionId.toString() + randNumber;
    this.videoSessionId = this.masterSPNData[EVENT_MAPPING.video_session_id];
    if (!window.godavariAnalyticsSessionData.hasOwnProperty(this.videoSessionId)) {
      window.godavariAnalyticsSessionData[this.videoSessionId] = this.videoSessionStartTime;
    }
  };

  registerBodyUnload() {
    window.addEventListener("beforeunload", this.onUnload.bind(this));
  }

  onUnload() {
    if (this.analyticsConfig.GODAVARI_ENABLED) {
      let masterData = localStorage.getItem("spnSdkData");
      masterData = JSON.parse(masterData);
      this.masterSPNData[EVENT_MAPPING.app_user_id] = masterData.app_user_id;
      this.masterSPNData[EVENT_MAPPING.app_device_id] =
        masterData.app_device_id;
      this.masterSPNData[EVENT_MAPPING.app_version] = masterData.app_version;
      this.masterSPNData[EVENT_MAPPING.app_geo_location] =
        masterData.app_geo_location;
      this.masterSPNData[EVENT_MAPPING.app_subscribe_type] =
        masterData.app_subscribe_type;
      this.masterSPNData[EVENT_MAPPING.app_partner_id] =
        masterData.app_partner_id;
      this.masterSPNData[EVENT_MAPPING.app_platform_type] =
        masterData.app_platform_type;
      this.masterSPNData[EVENT_MAPPING.app_operating_system] =
        masterData.app_operating_system;
      this.masterSPNData[EVENT_MAPPING.app_hardware] = masterData.app_hardware;
      this.masterSPNData[EVENT_MAPPING.custom_tags] = masterData.custom_tags;

      let shouldSendCustomDataExit = false;
      if (shouldSendCustomDataExit) {
        window.GODAVARI_EXIT_DATA = [
          {
            key: "custom_tag_1",
            value: "custom_tag_1_value",
          },
          {
            key: "custom_tag_2",
            value: "custom_tag_2_value",
          },
        ];
        let godavari_exit_data_window = window.GODAVARI_EXIT_DATA || [];
        let godavari_exit_data_local = [];
        if (godavari_exit_data_window.length > 0) {
          window.GODAVARI_EXIT_DATA = [];
        }
        let godavari_exit_data_local_Str =
          localStorage.getItem("godavari_exit_data");
        if (godavari_exit_data_local_Str) {
          localStorage.removeItem("godavari_exit_data");
          try {
            godavari_exit_data_local = JSON.parse(godavari_exit_data_local_Str);
          } catch (e) {
            godavari_exit_data_local = [
              {
                local_catch_error: godavari_exit_data_local,
              },
            ];
          }
        }
        let godavari_exit_data = this.prepareExitData(
          godavari_exit_data_local,
          godavari_exit_data_window
        );
        //this.masterSPNData[EVENT_MAPPING.custom_tags] = godavari_exit_data;
      }

      this.masterSPNData[EVENT_MAPPING.event_wall_clock] =
        this.getTimeDateFormat();
      this.masterSPNData[EVENT_MAPPING.event_time_zone] = this.getTimeZone();
      let eventData = this.masterSPNData;
      this.appSessionEnd("AppSessionEnd", eventData);
    }
  }

  prepareExitData(godavari_exit_data_local, godavari_exit_data_window) {
    let godavari_exit_data = {};

    if (godavari_exit_data_window.length > 0) {
      godavari_exit_data_window.forEach((element) => {
        godavari_exit_data[element.key] = godavari_exit_data[element.key] || "";
        godavari_exit_data[element.key] += element.value + "_";
      });
    }

    if (godavari_exit_data_local.length > 0) {
      godavari_exit_data_local.forEach((element) => {
        godavari_exit_data[element.key] = godavari_exit_data[element.key] || "";
        godavari_exit_data[element.key] += element.value + "_";
      });
    }

    return godavari_exit_data;
  }

  /**
   * When the app starts, the appStart function is called, which calls the appStart function in the
   * conn_obj object.
   * this method should be call once in player
   * @param eventName - The name of the event.
   * @param eventData - This is the data that you want to pass to the event.
   */
  appStart(eventName, eventData) {
    if (this.analyticsConfig.GODAVARI_ENABLED) {
      this.registerBodyUnload();
      this.platformType = eventData.app_platform_type;
      this.queueManager.updatePlatformType(eventData.app_platform_type);
      let timerValue = timerValueBasedOnConnection();
      setTimeout(() => {
        this.queueManager.removeUnusedGodavariKeyFromStorage();
        this.queueManager.checkAnalyticsPreviousSessionLength();
        this.queueManager.handleLastSessionData();
        this.queueManager.handleAllErrorSessionId();
        this.queueManager.handleAllVideoEndSessionId();
      }, timerValue);

      let os_name =
        eventData.app_operating_system != ""
          ? eventData.app_operating_system
          : this.getOs();
      os_name = os_name ? os_name : "und";
      let hardware =
        eventData.app_hardware != ""
          ? eventData.app_hardware
          : this.getDeviceType();
      hardware = hardware ? hardware : "und";

      let masterData = {
        app_user_id: eventData.app_user_id,
        app_device_id: eventData.app_device_id,
        app_subscribe_type: eventData.app_subscribe_type,
        app_geo_location: eventData.app_geo_location,
        app_version: eventData.app_version,
        app_partner_id: eventData.app_partner_id,
        app_platform_type: eventData.app_platform_type,
        app_operating_system: os_name,
        app_hardware: hardware,
        custom_tags: eventData.custom_tags
      };
      localStorage.setItem("spnSdkData", JSON.stringify(masterData));
      let platform = "";
      if (eventData.app_platform_type == "WEB") {
        platform = PLATFORM_CODE.WEB;
      } else if (eventData.app_platform_type == "MWEB") {
        platform = PLATFORM_CODE.MWEB;
      } else {
        platform = PLATFORM_CODE.SMARTTV;
      }

      this.masterSPNData[EVENT_MAPPING.app_platform_type] =
        eventData.app_platform_type;
      this.masterSPNData[EVENT_MAPPING.app_operating_system] = os_name;
      this.masterSPNData[EVENT_MAPPING.app_hardware] = hardware;
      this.masterSPNData[EVENT_MAPPING.app_user_id] = eventData.app_user_id;
      this.masterSPNData[EVENT_MAPPING.app_device_id] = eventData.app_device_id;

      eventData.event_wall_clock = this.getTimeDateFormat();
      eventData.event_time_zone = this.getTimeZone();

      let newEventData = this.eventDataTransformer(eventData);

      let appSessionId =
        platform +
        "-" +
        newEventData[EVENT_MAPPING.app_device_id] +
        "-" +
        this.masterSPNData[EVENT_MAPPING.app_session_id];
      this.masterSPNData[EVENT_MAPPING.app_session_id] =
        appSessionId.toString();

      newEventData = { ...newEventData, ...this.masterSPNData };
      this.sessionStartObj.getFireAppSessionStartEvents(
        eventName,
        newEventData
      );
    }
  }

  /**
   * If the videoSessionStartStatus is false, then get the newEventData and add the masterSPNData to
   * it. Then, get the fireVSSEvents and start the heartbeat. Finally, set the videoSessionStartStatus
   * to true.
   * @param eventName - "videoSessionStart"
   * @param eventData - This is the data that you want to pass to the event.
   */
  videoSessionStart(eventName, eventData) {
    if (this.analyticsConfig.GODAVARI_ENABLED) {
      if (!this.playerEventStatus.videoSessionStartStatus) {
        this.platformType = eventData.app_platform_type;
        this.masterSPNData[EVENT_MAPPING.app_platform_type] = eventData.app_platform_type;
        this.masterSPNData[EVENT_MAPPING.app_user_id] = eventData.app_user_id;
        this.masterSPNData[EVENT_MAPPING.app_device_id] = eventData.app_device_id;
        // pulse time interval max count update
        if (this.platformType == "WEB" || this.platformType == "MWEB") {
          this.analyticsPulseConfig.maxPulseBeaconLimit = DEFAULT_PULSE_MAX_COUNT.WEB;
          this.analyticsPulseConfig.beaconTimeInterval = DEFAULT_PULSE_TIME_INTERVAL.WEB;
        } else {
          this.analyticsPulseConfig.maxPulseBeaconLimit = DEFAULT_PULSE_MAX_COUNT.TV;
          this.analyticsPulseConfig.beaconTimeInterval = DEFAULT_PULSE_TIME_INTERVAL.TV;
        }

        if (eventData.video_session_id && typeof eventData.video_session_id != "undefined") {

          this.videoSessionStartTime = parseInt(
            eventData.event_wall_clock
          );
          this.masterSPNData[EVENT_MAPPING.video_session_start_time] = parseInt(
            eventData.event_wall_clock
          );
          this.masterSPNData[EVENT_MAPPING.video_session_id] = eventData.video_session_id.toString();
          this.videoSessionId = this.masterSPNData[EVENT_MAPPING.video_session_id];
          if (
            !window.godavariAnalyticsSessionData.hasOwnProperty(
              this.videoSessionId
            )
          ) {
            window.godavariAnalyticsSessionData[this.videoSessionId] =
              this.videoSessionStartTime;
          }
        } else {
          this.setVideoSessionId(eventData);
        }
        let newEventData = this.eventDataTransformer(eventData);
        newEventData = { ...newEventData, ...this.masterSPNData };
        this.videoSessionStartObj.getFireVideoSessionStartEvents(
          eventName,
          newEventData
        );
        this.playerEventStatus.videoSessionStartStatus = true;
        this.playerEventStatus.videoEndStatus = false;
        this.playerEventStatus.videoSessionEndStatus = false;
        this.startPulse();
        this.startHeartbeat();
      }
    }
  }

  /**
   * If the videoAttemptStatus is false, then get the eventData and masterSPNData and pass it to the
   * videoAttemptObj.getFireVideoAttemptEvents function.
   * @param eventName - "videoAttempt"
   * @param eventData - This is the data that you want to pass to the event.
   */
  videoAttempt(eventName, eventData) {
    if (
      this.videoSessionId &&
      !this.playerEventStatus.videoAttemptStatus &&
      this.analyticsConfig.GODAVARI_ENABLED
    ) {
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.videoAttemptObj.getFireVideoAttemptEvents(eventName, newEventData);
      this.playerEventStatus.videoAttemptStatus = true;
    }
  }

  /**
   * If the videoPlayStatus is false, then call the getFireVideoPlayEvents function and set the
   * videoPlayStatus to true.
   * @param eventName - 'videoPlay'
   * @param eventData - This is the data that you want to pass to the event.
   */
  videoPlay(eventName, eventData) {
    if (
      this.videoSessionId &&
      !this.playerEventStatus.videoPlayStatus &&
      this.analyticsConfig.GODAVARI_ENABLED
    ) {
      this.lastPulseRequest();
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.videoPlayObj.getFireVideoPlayEvents(eventName, newEventData);
      this.playerEventStatus.videoPlayStatus = true;
    }
  }

  /**
   * It takes an event name and event data, transforms the event data, and then calls a function that
   * sends the event name and transformed event data to a third party.
   * @param eventName - 'videoError'
   * @param eventData - This is the data that you want to pass to the event.
   */
  videoError(eventName, eventData) {
    if (
      this.videoSessionId &&
      !this.playerEventStatus.videoErrorStatus &&
      this.analyticsConfig.GODAVARI_ENABLED
    ) {
      this.lastPulseRequest();
      this.lastHeartbeatRequest();
      let videoCodeErrorObj = this.errorCodeManager.getVideoErrorCode(eventName, eventData);
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData, ...videoCodeErrorObj };
      this.videoErrorObj.getFireVideoErrorEvents(eventName, newEventData);
      this.playerEventStatus.videoErrorStatus = true;
    }
  }

  /**
   * If the playerEventStatus.videoSessionHeartbeatStatus is false, then create a new object and call
   * the getFireVideoSessionHeartbeatEvents function.
   * If the playerEventStatus.videoSessionHeartbeatStatus is true, then set the
   * playerEventStatus.videoSessionHeartbeatStatus to false and log an error.
   * </code>
   * @param eventName - 'videoSessionHeartbeat'
   * @param eventData - This is the data that is passed to the function.
   */
  videoSessionHeartbeat(eventName, eventData) {
    if (this.videoSessionId && this.analyticsConfig.GODAVARI_ENABLED) {
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.videoSessionHeartbeatObj.getFireVideoSessionHeartbeatEvents(
        eventName,
        newEventData
      );
    }
  }

  /**
   * If the videoEndStatus property of the playerEventStatus object is false, then the videoEndObj
   * object's getFireVideoEndEvents method is called with the eventName and newEventData parameters.
   *
   * The videoEndStatus property is set to true.
   * @param eventName - 'videoEnd'
   * @param eventData - This is the data that is passed to the function.
   */
  videoEnd(eventName, eventData) {
    if (
      this.videoSessionId &&
      !this.playerEventStatus.videoEndStatus &&
      this.analyticsConfig.GODAVARI_ENABLED
    ) {
      this.lastPulseRequest();
      this.lastHeartbeatRequest();
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.videoEndObj.getFireVideoEndEvents(eventName, newEventData);
      this.playerEventStatus.videoEndStatus = true;
    }
  }

  /**
   * It checks if the videoSessionEndStatus is false, if it is, it calls the getFireVideoSessionEndEvents
   * function, sets the videoSessionEndStatus to true, calls the updateFlagStatus function, and removes
   * the videoSessionID from the dataStoreObj.
   * @param eventName - "videoSessionEnd"
   * @param eventData - This is the data that is passed to the function.
   */
  videoSessionEnd(eventName, eventData) {
    if (
      this.videoSessionId &&
      !this.playerEventStatus.videoSessionEndStatus &&
      this.analyticsConfig.GODAVARI_ENABLED
    ) {
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.videoSessionEndObj.getFireVideoSessionEndEvents(
        eventName,
        newEventData
      );
      this.playerEventStatus.videoSessionEndStatus = true;
      this.updatePlayerFlagStatus();
      if (
        window.godavariAnalyticsSessionData.hasOwnProperty(
          newEventData[EVENT_MAPPING.video_session_id]
        )
      ) {
        delete window.godavariAnalyticsSessionData[newEventData[EVENT_MAPPING.video_session_id]];
      }
      this.videoSessionId = "";
    }
    clearInterval(this.pulseInterval);
  }

  /**
   * If the appSessionEndStatus is false, then get the eventData and masterSPNData and pass it to the
   * getFireAppSessionEndEvents function.
   * </code>
   * @param eventName - 'appSessionEnd'.
   * @param eventData - This is the data that is passed to the function.
   */
  appSessionEnd(eventName, eventData) {
    if (
      !window.ANALYTICS_CONNECTOR_FRONTEND.appSessionEndStatus &&
      this.analyticsConfig.GODAVARI_ENABLED
    ) {
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.appSessionEndObj.getFireAppSessionEndEvents(eventName, newEventData);
      this.playerEventStatus.appSessionEndStatus = true;
    }
  }

  updateVideoSession(actualEventData) {
    if (window.godavariAnalyticsSessionData.hasOwnProperty(actualEventData[EVENT_MAPPING.video_session_id])) {
      actualEventData[EVENT_MAPPING.video_session_start_time] = parseInt(window.godavariAnalyticsSessionData[actualEventData[EVENT_MAPPING.video_session_id]]);
      this.masterSPNData[EVENT_MAPPING.video_session_start_time] = actualEventData[EVENT_MAPPING.video_session_start_time];
      this.videoSessionId = actualEventData[EVENT_MAPPING.video_session_id];
      this.masterSPNData[EVENT_MAPPING.video_session_id] = actualEventData[EVENT_MAPPING.video_session_id];
    } else if (window.godavariAnalyticsSessionData.hasOwnProperty(this.masterSPNData[EVENT_MAPPING.video_session_id])) {
      actualEventData[EVENT_MAPPING.video_session_start_time] = parseInt(window.godavariAnalyticsSessionData[this.masterSPNData[EVENT_MAPPING.video_session_id]]);
      this.masterSPNData[EVENT_MAPPING.video_session_start_time] = actualEventData[EVENT_MAPPING.video_session_start_time];
    }
    return actualEventData;
  }

  /**
   * It takes a JSON object, and returns a JSON object.
   * @param rawEventData - This is the data that is sent to the server.
   */
  eventDataTransformer(rawEventData) {
    rawEventData = rawEventData || {};
    let actualEventData = {};
    for (let key in rawEventData) {
      if (EVENT_MAPPING[key]) {
        actualEventData[EVENT_MAPPING[key]] = rawEventData[key];
      }
    }

    actualEventData = this.updateVideoSession(actualEventData);

    if (actualEventData.hasOwnProperty(EVENT_MAPPING.app_version)) {
      actualEventData[EVENT_MAPPING.app_version] = actualEventData[EVENT_MAPPING.app_version] || "0";
    }else{
      actualEventData[EVENT_MAPPING.app_version] = "0";
    }

    if(actualEventData.hasOwnProperty(EVENT_MAPPING.app_platform_type) && actualEventData[EVENT_MAPPING.app_platform_type]){
      this.masterSPNData[EVENT_MAPPING.app_platform_type] = actualEventData[EVENT_MAPPING.app_platform_type];
    }

    if (actualEventData.hasOwnProperty(EVENT_MAPPING.video_session_start_time) && actualEventData[EVENT_MAPPING.video_session_start_time] === "") {
      actualEventData[EVENT_MAPPING.video_session_start_time] = 0;
    }

    if (actualEventData.hasOwnProperty(EVENT_MAPPING.video_session_start_time) && actualEventData[EVENT_MAPPING.video_session_start_time] > actualEventData[EVENT_MAPPING.event_wall_clock]) {
      actualEventData[EVENT_MAPPING.event_wall_clock] = this.getTimeDateFormat();
    }

    if (actualEventData.hasOwnProperty(EVENT_MAPPING.video_network_type) && actualEventData[EVENT_MAPPING.video_network_type] != "") {
      this.masterSPNData[EVENT_MAPPING.video_network_type] = actualEventData[EVENT_MAPPING.video_network_type];
    }else{
      this.masterSPNData[EVENT_MAPPING.video_network_type] = "und";
    }

    if (this.masterSPNData[EVENT_MAPPING.app_operating_system] == "") {
      this.masterSPNData[EVENT_MAPPING.app_operating_system] = "und";
      actualEventData[EVENT_MAPPING.app_operating_system] = "und";
    }

    if (this.masterSPNData[EVENT_MAPPING.app_hardware] == "" || this.masterSPNData[EVENT_MAPPING.app_hardware] == "undefined") {
      this.masterSPNData[EVENT_MAPPING.app_hardware] = "und";
      actualEventData[EVENT_MAPPING.app_hardware] = "und";
    }

    if (this.masterSPNData[EVENT_MAPPING.video_session_id] === "") {
      if (this.videoSessionId) {
        this.masterSPNData[EVENT_MAPPING.video_session_id] = actualEventData[EVENT_MAPPING.video_session_id];
        this.videoSessionId = actualEventData[EVENT_MAPPING.video_session_id];
      } else {
        this.setVideoSessionId(rawEventData);
        if (this.videoSessionId) {
          this.masterSPNData[EVENT_MAPPING.video_session_id] = this.videoSessionId;
          actualEventData[EVENT_MAPPING.video_session_id] = this.videoSessionId;
        } else {
          this.masterSPNData[EVENT_MAPPING.video_session_id] = "und";
          actualEventData[EVENT_MAPPING.video_session_id] = "und";
        }
      }
    }

    if (!this.masterSPNData.hasOwnProperty(EVENT_MAPPING.video_network_type)) {
      actualEventData[EVENT_MAPPING.video_network_type] = "und";
      this.masterSPNData[EVENT_MAPPING.video_network_type] = "und";
    }

    if (!actualEventData.hasOwnProperty(EVENT_MAPPING.video_audio_language)) {
      actualEventData[EVENT_MAPPING.video_audio_language] = "und";
    } else if (actualEventData.hasOwnProperty(EVENT_MAPPING.video_audio_language) && actualEventData[EVENT_MAPPING.video_audio_language] === undefined) {
      actualEventData[EVENT_MAPPING.video_audio_language] = "und";
    }

    if (!actualEventData.hasOwnProperty(EVENT_MAPPING.video_position)) {
      actualEventData[EVENT_MAPPING.video_position] = 0;
    }else{
    actualEventData[EVENT_MAPPING.video_position] = actualEventData[EVENT_MAPPING.video_position] ? actualEventData[EVENT_MAPPING.video_position] : 0;
    }

    actualEventData[EVENT_MAPPING.video_video_type] =
      actualEventData[EVENT_MAPPING.video_video_type] == "live"
        ? actualEventData[EVENT_MAPPING.video_video_type]
        : "vod";

    if (!actualEventData.hasOwnProperty(EVENT_MAPPING.video_content_id)) {
      actualEventData[EVENT_MAPPING.video_content_id] = 1;
    }else{
      actualEventData[EVENT_MAPPING.video_content_id] =
      actualEventData[EVENT_MAPPING.video_content_id] ? parseInt(actualEventData[EVENT_MAPPING.video_content_id])
        : 1;
    }
    
    actualEventData[EVENT_MAPPING.video_sequence] =
      actualEventData[EVENT_MAPPING.video_sequence] != "NA"
        ? parseInt(actualEventData[EVENT_MAPPING.video_sequence])
        : 0;
    actualEventData[EVENT_MAPPING.video_position] =
      actualEventData[EVENT_MAPPING.video_position] != "0"
        ? parseInt(actualEventData[EVENT_MAPPING.video_position])
        : 0;
    actualEventData[EVENT_MAPPING.video_length] =
      actualEventData[EVENT_MAPPING.video_length] != "0"
        ? parseInt(actualEventData[EVENT_MAPPING.video_length])
        : 0;
    actualEventData[EVENT_MAPPING.normalized_watch_time] =
      actualEventData[EVENT_MAPPING.normalized_watch_time] != "0"
        ? parseInt(actualEventData[EVENT_MAPPING.normalized_watch_time])
        : 0;
    actualEventData[EVENT_MAPPING.video_current_bitrate] =
      actualEventData[EVENT_MAPPING.video_current_bitrate] > 0
        ? parseInt(actualEventData[EVENT_MAPPING.video_current_bitrate])
        : 0;
    actualEventData[EVENT_MAPPING.ads_length_duration] = actualEventData[EVENT_MAPPING.ads_length_duration] > 0 ? Math.ceil(actualEventData[EVENT_MAPPING.ads_length_duration]) : 0;

    /**
     * ads session
     */
    if (Object.keys(window.godavariAnalyticsAdsSessionData).length > 0 && window.godavariAnalyticsAdsSessionData["adsSessionId"] !== "") {
      actualEventData = this.updateAdsVideoSession(actualEventData);

      if (actualEventData.hasOwnProperty(EVENT_MAPPING.ads_session_id) && actualEventData[EVENT_MAPPING.ads_session_id] === "") {
        actualEventData[EVENT_MAPPING.ads_session_id] = "und";
      }

      if (actualEventData.hasOwnProperty(EVENT_MAPPING.ads_session_start_epoch_time) && actualEventData[EVENT_MAPPING.ads_session_start_epoch_time] === "") {
        actualEventData[EVENT_MAPPING.ads_session_start_epoch_time] = 0;
      }
    }

    /**
     * heartbeat or pulse event list
     */
    if (rawEventData?.event_data_list?.length > 0) {
      if (actualEventData[EVENT_MAPPING.video_event_type] == ANALYTICS_EVENT_NAME.VIDEO_VIDEO_SESSION_PULSE) {
        actualEventData[EVENT_MAPPING.heart_beat_events] =
          this.eventPulseTransform(actualEventData, rawEventData.event_data_list);
      } else {
        actualEventData[EVENT_MAPPING.heart_beat_events] =
          this.eventHeartBeatTransform(actualEventData, rawEventData.event_data_list);
      }
    }

    actualEventData[EVENT_MAPPING.custom_tags] = rawEventData.custom_tags || {};

    return actualEventData;
  }

  eventHeartBeatTransform(actualEventData, heartBeatEvents) {
    var eventData = [];
    for (var i = 0; i < heartBeatEvents.length; i++) {
      let eventIndex = heartBeatEvents[i];

      if (actualEventData[EVENT_MAPPING.video_session_start_time] > eventIndex.event_wall_clock) {
        eventIndex.event_wall_clock = this.getTimeDateFormat();
      }

      var eachEventData = {
        e: EVENT_MAPPING[eventIndex.event_event_type],
        wc: eventIndex.event_wall_clock,
        tz: eventIndex.event_time_zone,
        pbr: eventIndex.event_current_playback_rate
      };

      //player events
      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_seek ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_buffer ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_buffer_start ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_buffer_end ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_resume ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_pause ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_dropped_frames
      ) {
        eachEventData[EVENT_MAPPING.event_start_position] =
          eventIndex.event_start_position;
      }
      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_seek
      ) {
        eachEventData[EVENT_MAPPING.event_end_position] =
          eventIndex.event_end_position;
      }
      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_buffer ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_buffer_start
      ) {
        eachEventData[EVENT_MAPPING.event_duration] = eventIndex.event_duration;
      }
      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_upshift ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_downshift
      ) {
        eachEventData[EVENT_MAPPING.event_from_bitrate] =
          eventIndex.event_from_bitrate;
        eachEventData[EVENT_MAPPING.event_to_bitrate] =
          eventIndex.event_to_bitrate;
      }
      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_dropped_frames
      ) {
        eachEventData[EVENT_MAPPING.event_increment_number] =
          eventIndex.event_increment_number;
      }
      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_buffer_health
      ) {
        eachEventData[EVENT_MAPPING.event_buffer_health] =
          eventIndex.event_buffer_health;
      }

      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_network_activity
      ) {
        let networkActivityData = [];
        for (
          var net = 0;
          net < eventIndex.event_network_activity.length;
          net++
        ) {
          let networkData = {};
          networkData[EVENT_MAPPING.event_net_download_speed] =
            eventIndex.event_network_activity[net].event_net_download_speed;
          networkData[EVENT_MAPPING.event_content_type] =
            eventIndex.event_network_activity[net].event_content_type;
          networkActivityData.push(networkData);
        }
        eachEventData[EVENT_MAPPING.event_network_activity] =
          networkActivityData;
      }

      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_video_resize
      ) {
        eachEventData[EVENT_MAPPING.event_video_resolution] =
          eventIndex.event_video_resolution;
        eachEventData[EVENT_MAPPING.event_viewport_size] =
          eventIndex.event_viewport_size;
      }
      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_golive
      ) {
        eachEventData[EVENT_MAPPING.event_live_latency] =
          eventIndex.event_live_latency;
      }
      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_network_change
      ) {
        eachEventData[EVENT_MAPPING.event_network_connectivity] =
          eventIndex.event_network_connectivity;
      }
      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_audio_language
      ) {
        eachEventData[EVENT_MAPPING.from_audio_language] =
          eventIndex.from_audio_language;
        eachEventData[EVENT_MAPPING.to_audio_language] =
          eventIndex.to_audio_language;
      }
      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_event_subtitle_language
      ) {
        eachEventData[EVENT_MAPPING.from_subtitle_language] =
          eventIndex.from_subtitle_language;
        eachEventData[EVENT_MAPPING.to_subtitle_language] =
          eventIndex.to_subtitle_language;
      }

      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_network_bandwidth
      ) {
        eachEventData[EVENT_MAPPING.network_bandwidth_bucket] =
          eventIndex.network_bandwidth_bucket;
        eachEventData[EVENT_MAPPING.current_bitrate] =
          eventIndex.current_bitrate;
      }

      // speed
      if (EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_speed_change) {
        eachEventData[EVENT_MAPPING.event_former_playback_rate] =
          eventIndex.event_former_playback_rate;
        eachEventData[EVENT_MAPPING.event_current_playback_rate] =
          eventIndex.event_current_playback_rate;
        eachEventData[EVENT_MAPPING.event_playing_state] =
          eventIndex.event_playing_state;
      }

      if (EVENT_MAPPING.heart_beat_live_to_ad || EVENT_MAPPING.heart_beat_live_to_ad_to_live || EVENT_MAPPING.heart_beat_ad_to_live) {
        eachEventData[EVENT_MAPPING.event_admrk_id] =
          eventIndex.event_admrk_id;
      }

      // player ads events

      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_ads_event_ad_click ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_ads_event_ad_skip ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_ads_event_ad_buffer ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_ads_event_ad_buffer_start ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_ads_event_ad_buffer_end ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_ads_event_ad_pause ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_ads_event_ad_resume
      ) {
        eachEventData[EVENT_MAPPING.event_start_position] =
          eventIndex.event_start_position;
      }

      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_ads_event_ad_click
      ) {
        eachEventData[EVENT_MAPPING.heart_beat_event_ad_click_url] =
          eventIndex.heart_beat_event_ad_click_url;
      }

      if (
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_ads_event_ad_buffer ||
        EVENT_MAPPING[eventIndex.event_event_type] ==
        EVENT_MAPPING.heart_beat_ads_event_ad_buffer_start
      ) {
        eachEventData[EVENT_MAPPING.heart_beat_event_ad_buffer_dur] =
          eventIndex.heart_beat_event_ad_buffer_dur;
      }

      eventData.push(eachEventData);
    }
    return eventData;
  }

  eventPulseTransform(actualEventData, pulseEvents) {
    var eventData = [];
    for (var i = 0; i < pulseEvents.length; i++) {
      let eventIndex = pulseEvents[i];

      if (actualEventData[EVENT_MAPPING.video_session_start_time] > eventIndex.event_wall_clock) {
        eventIndex.event_wall_clock = this.getTimeDateFormat();
      }

      var eachEventData = {
        e: EVENT_MAPPING[eventIndex.event_event_type],
        wc: eventIndex.event_wall_clock,
        tz: eventIndex.event_time_zone,
      };
      eachEventData[EVENT_MAPPING.pulse_start_steps] =
        eventIndex.pulse_start_steps;
      eachEventData[EVENT_MAPPING.pulse_micro_steps] =
        eventIndex.pulse_micro_steps;
      eachEventData[EVENT_MAPPING.pulse_player_state] =
        eventIndex.pulse_player_state;
      eachEventData[EVENT_MAPPING.pulse_player_retry] =
        eventIndex.pulse_player_retry;
      eventData.push(eachEventData);
    }
    return eventData;
  }

  /**
   * This function is called by the player when it is ready to receive heartbeats.
   * @param playerHeartbeatRef - A reference to the playerHeartbeat object.
   */
  // TODO : interval should be pause be resume ,pause
  // video session start
  registerHeartbeat(playerHeartbeatRef) {
    this.playerHeartbeatRef = playerHeartbeatRef;
  }

  lastHeartbeatRequest() {
    if (typeof this.playerHeartbeatRef === "function") {
      let videoHeartbeat = this.playerHeartbeatRef();
      if (videoHeartbeat?.event_data_list.length > 0) {
        this.videoSessionHeartbeat("VideoHeartbeat", videoHeartbeat);
      }
      clearInterval(this.heartBeatInterval);
    }
  }

  /**
   * "If the playerHeartbeatRef is a function, then call the videoSessionHeartbeat function with the
   * arguments "VideoHeartbeat" and the result of calling the playerHeartbeatRef function."</code>
   */
  startHeartbeat() {
    clearInterval(this.heartBeatInterval);
    this.heartBeatInterval = setInterval(() => {
      if (typeof this.playerHeartbeatRef === "function") {
        //check video heartbeat updated or not
        let videoHeartbeat = this.playerHeartbeatRef();
        if (videoHeartbeat?.event_data_list.length > 0) {
          this.videoSessionHeartbeat("VideoHeartbeat", videoHeartbeat);
        }
      }
    }, this.analyticsConfig.GODAVARI_HEARTBEAT_INTERVAL);
  }

  // Ads methods defining
  adsAttempt(eventName, eventData) {
    if (this.videoSessionId && !this.playerAdsEventStatus.adsVideoAttemptStatus && this.analyticsConfig.GODAVARI_ENABLED) {
      this.adsSessionId = "";
      this.videoAdStartStatus = false;
      window.godavariAnalyticsAdsSessionData["adsSessionId"] = "";
      this.setAdsVideoSessionId(eventData);
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.adAttemptObj.getFireAdAttempt(eventName, newEventData);
      this.playerAdsEventStatus.adsVideoAttemptStatus = true;
      this.playerAdsEventStatus.adsVideoEndStatus = false;
      this.playerAdsEventStatus.adsVideoErrorStatus = false;
      this.playerAdsEventStatus.adsVideoPlayStatus = false;
    }
  }

  adsPlay(eventName, eventData) {
    if (this.videoSessionId && !this.playerAdsEventStatus.adsVideoPlayStatus && this.analyticsConfig.GODAVARI_ENABLED) {
      clearInterval(this.pulseInterval);
      this.videoAdStartStatus = true;
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.adPlayObj.getFireAdPlay(eventName, newEventData);
      this.playerAdsEventStatus.adsVideoPlayStatus = true;
    }
  }

  adsError(eventName, eventData) {
    if (
      !this.playerAdsEventStatus.adsVideoErrorStatus &&
      this.videoSessionId &&
      this.analyticsConfig.GODAVARI_ENABLED
    ) {
      let adsCodeErrorObj = this.errorCodeManager.getAdsErrorCode(eventName, eventData);
      this.setAdsVideoSessionId(eventData);
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData, ...adsCodeErrorObj };
      this.adErrorObj.getFireAdError(eventName, newEventData);
      this.playerAdsEventStatus.adsVideoErrorStatus = true;
      this.playerAdsEventStatus.adsVideoAttemptStatus = false;
      this.videoAdStartStatus = false;
    }
  }

  adsHeartbeat(eventName, eventData) {
    if (this.videoSessionId && !this.playerAdsEventStatus.adsVideoSessionHeartbeatStatus && this.analyticsConfig.GODAVARI_ENABLED) {
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.adHeartbeatObj.getFireAdHeartbeat(eventName, newEventData);
      this.playerAdsEventStatus.adsVideoSessionHeartbeatStatus = true;
    }
  }

  adsEnd(eventName, eventData) {
    if (this.videoSessionId && !this.playerAdsEventStatus.adsVideoEndStatus && this.analyticsConfig.GODAVARI_ENABLED) {
      if (
        this.videoSessionId &&
        !this.playerEventStatus.videoPlayStatus &&
        this.analyticsConfig.GODAVARI_ENABLED
      ) {
        this.startPulse();
      }
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.adEndObj.getFireAdEnd(eventName, newEventData);
      this.updateAdsPlayerFlagStatus();
      this.playerAdsEventStatus.adsVideoEndStatus = true;
      this.adsSessionId = "";
      window.godavariAnalyticsAdsSessionData["adsSessionId"] = "";
      this.videoAdStartStatus = false;
    }
  }

  setAdsVideoSessionId = (eventData) => {
    let platform = "";
    if (this.masterSPNData[EVENT_MAPPING.app_platform_type] == "WEB") {
      platform = PLATFORM_CODE.WEB;
    } else if (this.masterSPNData[EVENT_MAPPING.app_platform_type] == "MWEB") {
      platform = PLATFORM_CODE.MWEB;
    } else {
      platform = PLATFORM_CODE.SMARTTV;
    }

    if (!this.adsSessionId) {
      this.masterSPNData[EVENT_MAPPING.ads_session_start_epoch_time] = parseInt(
        eventData.event_wall_clock
      );
      let adsSessionId = platform + "-" + eventData.app_device_id + "-" + eventData.event_wall_clock;
      this.masterSPNData[EVENT_MAPPING.ads_session_id] =
        adsSessionId.toString();
      this.adsSessionId = adsSessionId.toString();
      window.godavariAnalyticsAdsSessionData["adsSessionId"] = adsSessionId.toString();
    }
  };

  updateAdsVideoSession(actualEventData) {
    if (Object.keys(window.godavariAnalyticsAdsSessionData).length > 0 && window.godavariAnalyticsAdsSessionData["adsSessionId"] !== "") {
      let adsStartSessionTime = window.godavariAnalyticsAdsSessionData["adsSessionId"].split("-");
      if (adsStartSessionTime.length > 0) {
        this.masterSPNData[EVENT_MAPPING.ads_session_start_epoch_time] = parseInt(adsStartSessionTime[adsStartSessionTime.length - 1]);
        actualEventData[EVENT_MAPPING.ads_session_start_epoch_time] = parseInt(adsStartSessionTime[adsStartSessionTime.length - 1]);
      }
      this.adsSessionId = window.godavariAnalyticsAdsSessionData["adsSessionId"];
      this.masterSPNData[EVENT_MAPPING.ads_session_id] = window.godavariAnalyticsAdsSessionData["adsSessionId"];
      actualEventData[EVENT_MAPPING.ads_session_id] = window.godavariAnalyticsAdsSessionData["adsSessionId"];
    }
    return actualEventData;
  }

  handlePreviousSession(sessionData) {
    this.masterSPNData[EVENT_MAPPING.video_session_id] = sessionData.video_session_id;
    this.videoSessionId = this.masterSPNData[EVENT_MAPPING.video_session_id];
  }

  previousVideoSessionHeartbeat(eventName, eventData) {
    if (this.videoSessionId && this.analyticsConfig.GODAVARI_ENABLED) {
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.videoSessionHeartbeatObj.getFireVideoSessionHeartbeatEvents(
        eventName,
        newEventData
      );
    }
  }

  previousVideoEnd(eventName, eventData) {
    if (
      this.videoSessionId &&
      this.analyticsConfig.GODAVARI_ENABLED
    ) {
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.videoEndObj.getFireVideoEndEvents(eventName, newEventData);
    }
  }

  previousVideoSessionEnd(eventName, eventData) {
    if (
      this.videoSessionId &&
      this.analyticsConfig.GODAVARI_ENABLED
    ) {
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.videoSessionEndObj.getFireVideoSessionEndEvents(
        eventName,
        newEventData
      );
    }
  }

  videoSessionAppForeGround(eventName, eventData) {
    if (this.videoSessionId && this.analyticsConfig.GODAVARI_ENABLED) {
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.appForeGroundObj.getFireAppForeGroundEvents(
        eventName,
        newEventData
      );
    }
  }

  videoSessionAppBackGround(eventName, eventData) {
    if (this.videoSessionId && this.analyticsConfig.GODAVARI_ENABLED) {
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.appBackGroundObj.getFireAppBackGroundEvents(
        eventName,
        newEventData
      );
    }
  }


  //================== godavari Modified Player State ===================

  // store
  godavariStateVideoError(eventName, eventData) {
    if (this.videoSessionId) {
      let videoCodeErrorObj = this.errorCodeManager.getVideoErrorCode(eventName, eventData);
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData, ...videoCodeErrorObj };
      this.videoErrorObj.getGodavariStateFireVideoErrorEvents(eventName, newEventData);
    }
  }

  // store
  godavariStateVideoSessionEnd(eventName, eventData) {
    if (this.videoSessionId) {
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.videoSessionEndObj.getGodavariFireVideoSessionEndEvents(
        eventName,
        newEventData
      );
    }
  }

  // remove session data
  removeGodavariStateSessionData = (beaconType, sessionId) => {
    if (beaconType == ANALYTICS_EVENT_NAME.VIDEO_VIDEO_SESSION_VIDEOERROR) {
      this.videoErrorObj.removeVideoErrorFromALLError(sessionId);
    } else if (beaconType == ANALYTICS_EVENT_NAME.VIDEO_VIDEO_SESSION_END) {
      this.videoSessionEndObj.removeVideoEndFromALLEnd(sessionId);
    }
  };

  // when player gone on pause state give period of time video session has been close. 
  stopBeaconExecution() {
    if (window.beaconExecutionState) {
      window.beaconExecutionState = false;
    }
  }

  /**
  * If the playerEventStatus.videoSessionPulseStatus is false, then create a new object and call
  * the getFireVideoSessionPulseEvents function.
  * If the playerEventStatus.videoSessionPulseStatus is true, then set the
  * playerEventStatus.videoSessionPulseStatus to false and log an error.
  * </code>
  * @param eventName - 'videoSessionPulse'
  * @param eventData - This is the data that is passed to the function.
  */
  videoSessionPulse(eventName, eventData) {
    if (this.videoSessionId && this.analyticsConfig.GODAVARI_ENABLED) {
      let newEventData = this.eventDataTransformer(eventData);
      newEventData = { ...newEventData, ...this.masterSPNData };
      this.videoSessionPulseObj.getFireVideoSessionPulseEvents(
        eventName,
        newEventData
      );
    }
  }

  setDefaultPulseConfig(appConfig = {}) {
    this.analyticsPulseConfig = { ...this.analyticsPulseConfig, ...appConfig };
  }

  resetPulseStart() {
    this.lastPulseStatus = true;
    this.startPulse();
  };

  /**
  * This function is called by the player when it is ready to receive pulse.
  * @param playerPulseRef - A reference to the playerHeartbeat object.
  */
  registerPulse(playerPulseRef) {
    this.playerPulseRef = playerPulseRef;
  }

  /**
   * "If the playerPulseRef is a function, then call the videoSessionPulse function with the
   * arguments "videoPulse" and the result of calling the playerPulseRef function."</code>
   */
  startPulse() {
    clearInterval(this.pulseInterval);
    this.pulseInterval = setInterval(() => {
      if (typeof this.playerPulseRef === "function") {
        //check video pulse updated or not
        let videoPulse = this.playerPulseRef();
        if (!this.lastPulseStatus) {
          clearInterval(this.pulseInterval);
        }
        if (videoPulse?.event_data_list?.length > 0) {
          this.videoSessionPulse("Pulse", videoPulse);
          let pulseCount = parseInt(videoPulse?.pulse_event_count_sequence);
          if (
            pulseCount > 0 && 
            pulseCount == this.analyticsPulseConfig?.maxPulseBeaconLimit
          ) {
            clearInterval(this.pulseInterval);
          }
        }
      }
    }, this.analyticsPulseConfig?.beaconTimeInterval);
  }

  lastPulseRequest() {
    // this function has to make sure should execute only one
    if (typeof this.playerPulseRef === "function" && this.lastPulseStatus) {
      let videoPulse = this.playerPulseRef();
      if (videoPulse?.event_data_list?.length > 0) {
        this.videoSessionPulse("Pulse", videoPulse);
      }
      clearInterval(this.pulseInterval);
      this.lastPulseStatus = false;
    }
  }

  updateForeignCountryStatus = (status) => {
    if (status == true) {
      this.isForeignCountry = status;
    }
  }

}

export default AnalyticsConnector;
